import {
  BottomSheet,
  BottomSheetContent,
  Button,
  Stack,
} from '@relay-towing/ui';
import { Camera, Plus } from '@phosphor-icons/react';

export type CallAddition = 'photos' | 'vehicle' | 'note';

/**
 * What a call under way can have added, from the Add beside its status
 * (Figma 895-20367): Photos, Vehicle and Note, each opening the sheet the
 * call's own section opens. Vehicle is left out once the call has one; it
 * is changed from its card instead.
 */
export function CallAddSheet({
  open,
  onOpenChange,
  offers,
  onPick,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** What this call can have added, in the sheet's order. */
  offers: readonly CallAddition[];
  onPick: (addition: CallAddition) => void;
}) {
  const pick = (addition: CallAddition) => {
    onOpenChange(false);
    onPick(addition);
  };
  return (
    <BottomSheet open={open} onOpenChange={onOpenChange}>
      <BottomSheetContent title="Add">
        <Stack gap={4}>
          {offers.includes('photos') ? (
            <Button
              variant="secondary"
              size="xl"
              pill
              fullWidth
              leadingIcon={<Camera />}
              onClick={() => pick('photos')}
            >
              Photos
            </Button>
          ) : null}
          {offers.includes('vehicle') ? (
            <Button
              variant="secondary"
              size="xl"
              pill
              fullWidth
              leadingIcon={<Plus />}
              onClick={() => pick('vehicle')}
            >
              Vehicle
            </Button>
          ) : null}
          {offers.includes('note') ? (
            <Button
              variant="secondary"
              size="xl"
              pill
              fullWidth
              leadingIcon={<Plus />}
              onClick={() => pick('note')}
            >
              Note
            </Button>
          ) : null}
        </Stack>
      </BottomSheetContent>
    </BottomSheet>
  );
}
